import { useQuery } from "react-query";
import { JobQuestionResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchJobQuestionKey = "job-question-key";

export async function fetchJobQuestion(
  JobID: string
): Promise<JobQuestionResponse> {
  const res = await ApiClient.get(`/JobQuestion?JOB_ID=${JobID}`);
  return res.data;
}

export default function useFetchJobQuestion(JobID: string) {
  return useQuery([fetchJobQuestionKey, JobID], queryWrapper(fetchJobQuestion));
}
